// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1BUZI","label":"CategoryService_label__3Mtes","location":"CategoryService_location__21Q_f"};